export enum basegameAssetConfig {

}